import React from "react";
import { Label } from "reactstrap";
import "./CustomCheckBoxLabelCss.css";
import classnames from "classnames";
import i18next from "i18next";

const CustomCheckBoxLabel = (props) => {
    const {
        label,
        classNames,
        value,
        groupName,
        onChange,
        active,
        onBlur,
        image,
        divStyle,
        extraStyle
    } = props;

    return (
        <Label
            className={classnames(
                "MenuTabs mt-2 p-1",
                extraStyle,
                classNames,
                { active: active === value }
            )}
        >
            <div
                className={classnames(
                    "d-flex align-items-center CustomCheckBox",
                    divStyle
                )}
            >

                {/* Device image - currently disabled */}
                {/*
                {groupName === "deviceType" && (
                    <div>
                        <img
                            src={`https://ghdear.com/ghadear_backend/public/assets/uploads/${image}`}
                            alt=""
                            className="deviceImage img-fluid"
                        />
                    </div>
                )}
                */}

                <input
                    name={groupName}
                    onChange={onChange}
                    value={value}
                    className={classnames("customInput", {
                        "d-none": groupName === "deviceType"
                    })}
                    type="radio"
                    id={typeof label === "string" ? label : value}
                    onBlur={onBlur}
                    checked={active === value}
                />

                {i18next.language === "ar" ? (
                    <span
                        className={classnames("ml-2 checkmark-ar", {
                            "d-none": groupName === "deviceType"
                        })}
                    ></span>
                ) : (
                    <span
                        className={classnames("checkmark", {
                            "d-none": groupName === "deviceType"
                        })}
                    ></span>
                )}

                {/* Label */}
                {typeof label === "object"
                    ? label?.name || label?.label || label?.title || ""
                    : label}

            </div>
        </Label>
    );
};

export default CustomCheckBoxLabel;